export default __webpack_public_path__ + "static/media/IPManagement.7165e959.svg";